"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePicker = void 0;
const React = require("react");
const theme_1 = require("../modules/theme");
const layout_1 = require("../modules/layout");
const format_1 = require("../modules/format");
const ImageButton_1 = require("./ImageButton");
const Modal_1 = require("./Modal");
const react_date_range_1 = require("react-date-range");
const react_native_1 = require("react-native");
require("react-date-range/dist/styles.css");
require("../../styles/RangeDatePicker.css");
class DatePicker extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showModal: false
        };
        this.calendarRef = React.createRef();
        this.handleClick = (event) => {
            if (this.calendarRef.current &&
                !this.calendarRef.current.contains(event.target)) {
                this.setState({ showModal: false });
            }
        };
        this.handlePress = () => {
            this.setState({ showModal: true });
        };
        this.handleClear = () => {
            this.props.onChange(undefined);
        };
        this.handleConfirm = (value) => {
            this.props.onChange(value);
            this.setState({ showModal: false });
        };
        this.getStyles = () => {
            const theme = (0, theme_1.getTheme)();
            const styles = react_native_1.StyleSheet.create({
                container: {
                    paddingLeft: 16,
                    paddingRight: 4,
                    paddingVertical: 8,
                    borderWidth: 1,
                    borderColor: theme.borderColor1,
                    borderRadius: 3,
                    flexDirection: 'row',
                    alignItems: 'center'
                },
                modalOverlay: {
                    justifyContent: 'center',
                    alignItems: 'center'
                },
                label: {
                    color: theme.textColor2,
                    fontFamily: theme.fontFamily3,
                    fontSize: (0, layout_1.isTablet)() ? 15 : 12,
                    lineHeight: 16
                },
                value: {
                    color: theme.textColor1,
                    fontFamily: theme.fontFamily1,
                    fontSize: 16,
                    lineHeight: 22,
                    minHeight: 22
                },
                clearIcon: {
                    borderWidth: 0,
                    marginLeft: 'auto'
                }
            });
            return styles;
        };
    }
    componentWillMount() {
        document.addEventListener('mousedown', this.handleClick, false);
    }
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClick, false);
    }
    render() {
        const { label, value, clearable, style, dateFormat, nativeID } = this.props;
        const styles = this.getStyles();
        const theme = (0, theme_1.getTheme)();
        return (React.createElement(react_native_1.TouchableWithoutFeedback, { onPress: this.handlePress },
            React.createElement(react_native_1.View, { nativeID: nativeID, style: [styles.container, style] },
                React.createElement(react_native_1.View, { ref: ref => ref &&
                        ref.setNativeProps &&
                        ref.setNativeProps({ id: 'date-picker' }) },
                    React.createElement(react_native_1.Text, { style: styles.label }, label),
                    React.createElement(react_native_1.Text, { style: styles.value }, value != undefined ? (0, format_1.formatDate)(value, dateFormat) : '')),
                React.createElement(ImageButton_1.ImageButton, { icon: value && clearable ? 'times' : 'calendar', style: styles.clearIcon, iconColor: value && clearable ? theme.textColor1 : theme.textColor2, onPress: value && clearable ? this.handleClear : this.handlePress, hitBoxSize: 30 }),
                React.createElement(Modal_1.Modal, { visible: this.state.showModal, overlayStyle: styles.modalOverlay },
                    React.createElement("div", { ref: this.calendarRef, style: {
                            borderRadius: '5px',
                            position: 'absolute',
                            top: '50%',
                            marginTop: '-150px',
                            fontFamily: theme.fontFamily1
                        } },
                        React.createElement(react_date_range_1.Calendar, { locale: (0, format_1.getDateFnsLocale)(), date: value, onChange: this.handleConfirm, weekdayDisplayFormat: (0, format_1.getLocale)() === 'pt' ? 'EEEEEE' : 'E' }))))));
    }
}
exports.DatePicker = DatePicker;
DatePicker.defaultProps = {
    clearable: true,
    dateFormat: 'cccc, dd/MM/yyyy'
};
